import Popover from 'trunks/vue/admin/components/libs/popover.js';

const optionItemComp = {
  name: 'option-item',
  props: ['option', 'index', 'type'],

  data() {
    return {
      settingsEnable: false,
      maxSetting: this.option.settings && this.option.settings.limit_settings && this.option.settings.limit_settings.max,
      textSetting: this.option.settings && this.option.settings.limit_settings && this.option.settings.limit_settings.text,
    };
  },

  template: `
    <div class="option-item">
      <div class="dragable option-dragarea">
        <i class="slp-move text-large dragable"></i>
      </div>
      <div class="option-wrapper justify-box">
        <i :class='type === "radio" ? "slp-circle-o" : "slp-square-o"'></i>
        <input type="text"
               class='option-value-input content'
               v-model.trim='option.value'
               ref='input'
               @blur='inputBlured(index, $event)'
               @keyup.enter='enter(index, $event)'
               @keydown.delete='deleteKeyEnter(index, $event)' />
        <span class="option-settings-trigger" @click='toggleSettings'>
          <i :class='isLimitOn() ? "slp-check" : "slp-empty" '></i>
          <span>设置上限</span>
        </span>
        <span class="destroy-option-btn text-strong" @click='removeOption'>
          <i class="slp-times"></i>
        </span>
      </div>
      <div class="option-settings-container justify-box" v-show='settingsEnable'>
        <label class="setting-item content justify-box">
          <span>填写上限</span>
          <input class='content'
                 placeholder='小于0或为空时，无上限'
                 type="number"
                 min=0
                 :value='maxSetting'
                 @input='updateMaxSetting'
                 @blur='updateMaxSetting' />
        </label>
        <label class="setting-item content justify-box">
          <span>提示文案</span>
          <input class='content'
                 placeholder='已达上限'
                 type="text"
                 :value='textSetting'
                 @blur='updateTextSetting'
                 @input='updateTextSetting' />
        </label>
      </div>
    </div>
  `,

  watch: {
    maxSetting(newValue) {
      if (this.option.settings == null) this.option.settings = {};
      if (this.option.settings.limit_settings == null) this.option.settings.limit_settings = {};
      this.option.settings.limit_settings.max = newValue;
    },

    textSetting(newValue) {
      if (this.option.settings == null) this.option.settings = {};
      if (this.option.settings.limit_settings == null) this.option.settings.limit_settings = {};
      this.option.settings.limit_settings.text = newValue;
    },
  },

  methods: {
    toggleSettings() {
      this.settingsEnable = !this.settingsEnable;
    },

    enter(index, event) {
      this.$emit('keyEnter', index, event);
    },

    deleteKeyEnter(index, event) {
      this.$emit('keyDelete', index, event);
    },

    removeOption() {
      this.option.optionable.removeOption(this.option);
    },

    inputBlured(index, event) {
      this.$emit('inputBlured', index, event);
    },

    updateMaxSetting(event) {
      this._updateMax(event.target.value);
    },

    updateTextSetting(event) {
      this._updateText(event.target.value);
    },

    _updateMax(max) {
      const value = parseInt(max);
      this.maxSetting = _.isBlank(value) ? '' : value;
    },

    _updateText(text) {
      this.textSetting = (text && text.trim()) || '';
    },

    updateSetting(max, text) {
      this._updateMax(max);
      this._updateText(text);
    },

    isLimitOn() {
      return !_.isBlank(this.maxSetting);
    },

    select() {
      this.$nextTick(() => {
        this.$refs.input.select();
      });
    },

    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
  },
};

const OptionListComp = {
  name: 'option-list',

  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      type: String,
      default: 'radio',
    },
    optionable: {
      type: Skylark.App.Model.Field.Base,
      required: true,
    },
  },

  components: {
    'option-item': optionItemComp,
  },

  template: `
    <div class="option-list" v-sortable="{ item: '.option-item', dragarea: '.option-dragarea, i.text-strong', sortChangedFunc: sortChanged }">
      <option-item v-for='(option, index) in options'
                   v-if='!option._destroy'
                   :key='option.uuid'
                   :index='index'
                   :type='type'
                   :option='option'
                   ref='optionsItemInput'
                   @inputBlured='inputBlured'
                   @keyEnter='insertNewOption'
                   @keyDelete='deleteKeyEnter' />
    </div>
  `,

  computed: {
    filterOptions() {
      return _.filter(this.options, (option) => !option._destroy);
    },
  },

  methods: {
    inputBlured(index, event) {
      const optionValue = event.target.value.trim();
      if (!this.options[index]) return;
      if (optionValue) {
        this.updateOptionValueIfNeed(index, optionValue);
      } else {
        this.optionable.removeOption(this.options[index]);
      }
    },

    insertNewOption(index, event) {
      if (!this.options[index].value) return;
      this.updateOptionValueIfNeed(index, event.target.value.trim());
      const newOption = this.optionable.insertOption(index + 1);
      this.$nextTick(() => {
        const currentIndex = _.indexOf(this.filterOptions, newOption);
        this.$refs.optionsItemInput[currentIndex].select();
      });
    },

    deleteKeyEnter(index, event) {
      if (this.options[index].value) return;
      const currentIndex = _.indexOf(this.filterOptions, this.options[index]);
      if (currentIndex < 1) return;
      this.optionable.removeOption(this.options[index]);
      event.preventDefault();
      this.$nextTick(() => {
        this.$refs.optionsItemInput[currentIndex - 1].focus();
      });
    },

    updateOptionValueIfNeed(index, value, options = { silent: false }) {
      const matches = value.match(/([^;；]+)(?:[;；](\d+)(?:[;；](.+))?)$/);
      if (!matches) return false;
      this.options[index].value = matches[1];
      this.$nextTick(() => {
        const option = this.$refs.optionsItemInput[index];
        option.updateSetting(matches[2], matches[3]);
        if (!options.silent) this.$emit('valueChanged');
      });
      return true;
    },

    sortChanged(currentIndex, targetIndex) {
      if (currentIndex === targetIndex) return;
      this.optionable.moveOptionTo(this._mapIndex(currentIndex), this._mapIndex(targetIndex));
    },

    _mapIndex(index) {
      return _.indexOf(this.options, this.filterOptions[index]);
    },
  },
};

export default {
  components: {
    Popover,
    OptionList: OptionListComp,
  },

  data() {
    return {
      type: 'selection',
      otherOptionSettingEnable: false,
      remote_options_url: this.field.dig('settings', 'callback_url'),
      maxSetting: this.field.settings.other_option_settings
        && this.field.settings.other_option_settings.limit
        && this.field.settings.other_option_settings.limit.max,
      textSetting: this.field.settings.other_option_settings
        && this.field.settings.other_option_settings.limit
        && this.field.settings.other_option_settings.limit.text,
    };
  },

  watch: {
    remote_options_url(newValue) {
      if (this.field.settings == null) this.field.settings = {};
      this.field.settings.callback_url = newValue;
    },

    maxSetting(newValue) {
      if (this.field.settings == null) this.field.settings = {};
      if (this.field.settings.other_option_settings == null) this.field.settings.other_option_settings = {};
      if (this.field.settings.other_option_settings.limit == null) this.field.settings.other_option_settings.limit = {};
      this.field.settings.other_option_settings.limit.max = newValue;
      this.field.updateOtherOption();
    },

    textSetting(newValue) {
      if (this.field.settings == null) this.field.settings = {};
      if (this.field.settings.other_option_settings == null) this.field.settings.other_option_settings = {};
      if (this.field.settings.other_option_settings.limit == null) this.field.settings.other_option_settings.limit = {};
      this.field.settings.other_option_settings.limit.text = newValue;
      this.field.updateOtherOption();
    },

    'field.other_option': _.debounce(function() {
      this.field.updateOtherOption();
    }, 600),
  },

  computed: {
    otherOption() {
      return this.field.otherOption;
    },
  },

  methods: {
    updateOtherMaxSetting(event) {
      this._updateOtherMax(event.target.value);
    },

    updateOtherTextSetting(event) {
      this._updateOtherText(event.target.value);
    },

    addOption() {
      this.field.insertOption();
    },

    toggleOtherOption() {
      this.field.toggleOtherOption();
      if (this.field.hasOtherOption) {
        this.$nextTick(() => {
          this.$refs.otherOptionInput.select();
        });
      }
    },

    cancelPopover() {
      this.$refs.popover.close();
    },

    toggleOtherOptionSetting() {
      this.otherOptionSettingEnable = !this.otherOptionSettingEnable;
    },

    addOptions() {
      const optionsStr = this.$refs.multipleInput.value;
      this.$refs.multipleInput.value = '';
      this.$refs.popover.close();
      const options = _.filter(optionsStr.split(/[\r\n]+/), (option) => option.trim());
      if (!options.length) return;
      this.field.addOptions(options);
    },

    isLimitOn() {
      return !_.isBlank(this.maxSetting);
    },

    _updateOtherMax(max) {
      const value = parseInt(max);
      this.maxSetting = _.isBlank(value) ? '' : value;
    },

    _updateOtherText(text) {
      this.textSetting = (text && text.trim()) || '';
    },
  },
};
